import React from 'react'
import p from 'prop-types'
import {
  formatDistance,
  formatGrade,
  formatSpeed,
  formatDuration,
  formatPace
} from 'lib/units'

import {withMetricUnits} from 'common/units/MetricUnitsContext'
import _ from 'lodash'
import {softError} from 'lib/softError'

class _Unit extends React.PureComponent {
  static conversionOptionKeys = [
    'metricUnits',
    'smallUnits',
    'bigUnits',
    'biggestUnits',
    'units'
  ]

  static toStringOptionKeys = [
    'short',
    'useGrouping',
    'maximumFractionDigits',
    'minimumFractionDigits'
  ]
  /*
   * value...............raw numeric value to format, in rwgps native units
   * metricUnits.........convert to metric units instead of imperial
   * smallUnits..........force using the smaller units (i.e. meters instead of km)
   * bigUnits............force using the larger units (i.e. km instead of meters)
   * units...............force using a specific unit, ignoring metric/small/big props
   * valueOnly...........just render the value, not the label
   * labelOnly...........just render the label, not the value
   * children............render prop to customize rendering
   *                     Call signature should be (unitType) => React.Element.
   *                     See https://github.com/ridewithgps/rwgps-units#unittypes
   * formatter...........rwgps/units formatter function to use (required)
   */
  static propTypes = {
    value: p.number.isRequired,
    metricUnits: p.bool,
    smallUnits: p.bool,
    bigUnits: p.bool,
    units: p.string,
    valueOnly: p.bool,
    labelOnly: p.bool,
    children: p.func,
    formatter: p.func.isRequired
  }

  render () {
    const {value, formatter, children, valueOnly, labelOnly} = this.props
    const conversionOptions = _.pick(this.props, _Unit.conversionOptionKeys)
    const toStringOptions = _.pick(this.props, _Unit.toStringOptionKeys)
    const converted = formatter(value || 0, conversionOptions)
    // we have null metrics in production, hence the || 0 there

    if (typeof children === 'function') { return children(converted) }
    if (valueOnly) { return converted.valueToString(toStringOptions) }
    if (labelOnly) { return toStringOptions.short ? converted.short : converted.long }
    if (converted.toString(toStringOptions) === undefined) {
      softError('unit formatter returned undefined, this crashes React')
      return null
    }
    return converted.toString(toStringOptions)
  }
}

// read the metricUnits prop default from a MetricUnitsContext if one exists
const Unit = withMetricUnits(_Unit)

export const Distance = (props) => <Unit formatter={formatDistance} {...props} />
export const Elevation = (props) => <Unit formatter={formatDistance} smallUnits {...props} />
export const Grade = (props) => <Unit formatter={formatGrade} {...props} />
export const Speed = (props) => <Unit formatter={formatSpeed} minimumFractionDigits={1} {...props} />
export const Duration = (props) => <Unit formatter={formatDuration} {...props} />
export const Pace = (props) => <Unit formatter={formatPace} {...props} />
